module.exports = __webpack_public_path__ + "img/guangshanruiduRight.20356fbf.png";